<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>日报管理</el-breadcrumb-item>
      <el-breadcrumb-item>日报列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="row">
      <div class="col-sm-6">
        <div class="panel">
          <el-page-header @back="$router.go(-1)" content="日报详情">
          </el-page-header>
          <div class="panel-body">
            <dl class="dl-horizontal">
              <dt>所属日期</dt>
              <dd>
                {{ $time(report.created_at).format('YYYY-MM-DD HH:mm') }}
              </dd>
              <dt>钻进周期</dt>
              <dd>{{ report.work_day }}天</dd>

              <dt class="mt-10">当前井深(m)</dt>
              <dd class="mt-10">{{ report.current_pit_depth }}</dd>
              <dt>日进尺(m)</dt>
              <dd>{{ report.day_drilling_footage }}</dd>
              <dt>班进尺(m)</dt>
              <dd>{{ report.class_drilling_footage }}</dd>
              <dt>地层</dt>
              <dd>{{ report.stratum }}</dd>
              <dt>岩性</dt>
              <dd>{{ report.rock_character }}</dd>
              <dt class="dl-title">钻进参数</dt>
              <dd></dd>
              <dt>转速(r/min)</dt>
              <dd>{{ report.rotationl_speed }}</dd>
              <dt>排量(L/S)</dt>
              <dd>{{ report.displacement }}</dd>
              <dt>泵压(MPa)</dt>
              <dd>{{ report.pumping_pressure }}</dd>
              <dt>钻压(T)</dt>
              <dd>{{ report.drill_pressure }}</dd>
              <dt class="dl-title">泥浆参数</dt>
              <dd></dd>
              <dt>泥浆密度(g/cm³)</dt>
              <dd>{{ report.mud_density }}</dd>
              <dt>粘度(s)</dt>
              <dd>{{ report.mud_viscosity }}</dd>
              <dt class="dl-title">轨迹参数</dt>
              <dd></dd>
              <dt>测深(m)</dt>
              <dd>{{ report.trail_depth }}</dd>
              <dt>井斜(°)</dt>
              <dd>{{ report.tilt_degree }}</dd>
              <dt>磁方位(°)</dt>
              <dd>{{ report.magnetism_direction }}</dd>
              <dt>场强(nT)</dt>
              <dd>{{ report.field_strength }}</dd>
              <dt>倾角(°)</dt>
              <dd>{{ report.dip_angle }}</dd>
              <dt>重力(G)</dt>
              <dd>{{ report.gravity }}</dd>
              <dt class="mt-10">钻具组合</dt>
              <dd class="mt-10">{{ report.drilling_tools }}</dd>
              <dt>钻进状态</dt>
              <dd>{{ report.drill_status_name }}</dd>
              <dt>当前工况</dt>
              <dd>{{ report.working_condition }}</dd>
              <dt class="dl-title">仪器</dt>
              <dd></dd>
              <dt>厂家</dt>
              <dd>{{ report.instrument_manufactor }}</dd>
              <dt>编号</dt>
              <dd>{{ report.instrument_number }}</dd>
              <dt>探管</dt>
              <dd>{{ report.instrument_probe_tube }}</dd>
              <dt>脉冲</dt>
              <dd>{{ report.instrument_pulse }}</dd>
              <dt>电池</dt>
              <dd>{{ report.instrument_battery }}</dd>
              <dt>驱动</dt>
              <dd>{{ report.instrument_driver }}</dd>
              <dt>使用时间(h)</dt>
              <dd>{{ report.instrument_use_time }}</dd>
              <dt class="dl-title">螺杆</dt>
              <dd></dd>
              <dt>型号</dt>
              <dd>{{ report.screw_model }}</dd>
              <dt>厂家</dt>
              <dd>{{ report.screw_manufactor }}</dd>
              <dt>尺寸</dt>
              <dd>{{ report.screw_size }}</dd>
              <dt>编号</dt>
              <dd>{{ report.screw_number }}</dd>
              <dt>循环时间(h)</dt>
              <dd>{{ report.screw_loop_time }}</dd>
              <dt class="dl-title">钻头</dt>
              <dd></dd>
              <dt>厂家</dt>
              <dd>{{ report.drill_manufactor }}</dd>
              <dt>型号</dt>
              <dd>{{ report.drill_model }}</dd>
              <dt>尺寸(mm)</dt>
              <dd>{{ report.drill_size }}</dd>
              <dt>序列号</dt>
              <dd><DrillLink :no="report.drill_number"></DrillLink></dd>
              <dt>总纯钻时间(h)</dt>
              <dd>{{ report.drill_total_time }}</dd>
              <dt>总进尺(m)</dt>
              <dd>{{ report.drill_total_footage }}</dd>
              <dt>最快钻时(min/m)</dt>
              <dd>{{ report.drill_max_speed }}</dd>
              <dt>最慢钻时(min/m)</dt>
              <dd>{{ report.drill_min_speed }}</dd>
              <dt>定向钻时(min/m)</dt>
              <dd>{{ report.drill_directional_time }}</dd>
              <dt>当班机械钻速(m/h)</dt>
              <dd>{{ report.drill_current_speed }}</dd>
              <dt>总平均机械钻速(m/h)</dt>
              <dd>{{ report.drill_average_speed }}</dd>
              <dt class="dl-title">其他</dt>
              <dd></dd>
              <dt>循环温度(℃)</dt>
              <dd>{{ report.loop_temperature }}</dd>
              <dt>驻井人员</dt>
              <dd>{{ report.resident_person }}</dd>
              <dt>备注</dt>
              <dd>{{ report.remark }}</dd>
            </dl>
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="panel">
          <div class="panel-heading">
            <h3 class="panel-title">项目信息</h3>
          </div>
          <div v-if="report.project">
            <dl class="dl-horizontal">
              <dt>井号</dt>
              <dd>{{ report.project.pit_number }}</dd>
              <dt>井队</dt>
              <dd>{{ report.project.pit_team }}</dd>
              <dt>位置</dt>
              <dd>{{ report.project.position }}</dd>
              <dt>GPS</dt>
              <dd>{{ report.project.gps || '-' }}</dd>
              <dt>服务内容</dt>
              <dd>{{ report.project.service }}</dd>
              <dt>主眼设计井深</dt>
              <dd>{{ report.project.pit_depth }} m</dd>
              <dt>服务开始日期</dt>
              <dd>
                {{
                  report.project.start_time
                    ? $time(report.project.start_time).format('YYYY-MM-DD')
                    : '-'
                }}
              </dd>
            </dl>
          </div>
        </div>
        <div class="panel">
          <div class="panel-heading">
            <h3 class="panel-title">附件信息</h3>
          </div>
          <div class="">
            <div class="">
              <div class="panel-heading">
                <h3 class="panel-title">图片</h3>
              </div>

              <div class="demo-image__preview">
                <el-image
                  v-for="path in reportImgs"
                  :key="path"
                  style="width: 100px; height: 100px"
                  :src="path"
                  :preview-src-list="reportImgs"
                >
                </el-image>
              </div>

              <div id="demo-gallery" style="display: none">
                <!-- <a href="#">
                  <img
                    alt=""
                    src="{{ img.path }}"
                    data-image="{{ img.path }}"
                    data-description=""
                    style="display: none"
                  />
                </a> -->
              </div>
            </div>
            <!-- <div class="panel">
									<div class="panel-heading">
										<h3 class="panel-title">文件</h3>
									</div>
									<ul>
										<% report.attachments.where(:category_id => 3).map do |file| }}
										<li><a href="{{ file.path }}" target="_blank">{{ file.name }}</li></a>
										<% end }}
									</ul>
								</div> -->
            <div class="">
              <div class="panel-heading">
                <h3 class="panel-title">视频</h3>
              </div>
              <div class="">
                <div id="video-container">
                  <!-- <% report.attachments.where(:category_id => 2).map do |video|
                  }}
                  <video src="{{ video.path }}" controls="controls"></video>
                  <% end }} -->
                  <video
                    :src="path"
                    controls="controls"
                    v-for="path in reportVideos"
                    :key="path"
                  ></video>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<!-- <script>
	$(document).on('nifty.ready', function () {
		if ($('#demo-gallery > a').length > 0 ) {
			$("#demo-gallery").unitegallery({
				tile_enable_shadow: false
			});
		}
	});
</script> -->

<script>
import { reportDetail } from '../../../service/getData'
export default {
  data() {
    return {
      report: {
        attachments: [],
      },
    }
  },

  computed: {
    reportImgs() {
      return this.report.attachments
        .filter((item) => item.category_id == 1)
        .map((item) => {
          return item.path
        })
    },
    reportVideos() {
      return this.report.attachments
        .filter((item) => item.category_id == 2)
        .map((item) => {
          return item.path
        })
    },
  },
  created() {
    this.getData(this.$route.params.id)
  },
  methods: {
    async getData(id) {
      let res = await reportDetail(id)
      console.log(res)
      this.report = res.data
    },
  },
}
</script>

<style scoped>
.panel-title {
  padding-left: 0 !important;
}
</style>